import React from "react";
import * as Icons from "lucide-react";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Stagger, StaggerItem, Reveal } from "@/components/Reveal";
import { BookButton } from "@/components/ui-bits";
import { AMENITIES, IMAGES } from "@/lib/site";

export default function Amenities() {
  return (
    <>
      <Seo
        title="Hotel Amenities | Free Breakfast, WiFi & More — Pittsburg KS"
        description="Regency Inn & Suites amenities: free hot breakfast, free high-speed WiFi, pet-friendly rooms, in-room kitchenettes, laundry, business center, free & truck parking in Pittsburg, Kansas."
        path="/amenities"
        image={IMAGES.breakfast}
        schema={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Amenities", path: "/amenities" }])]}
      />
      <PageHero
        eyebrow="Amenities"
        title="More included, for less."
        subtitle="Everything you'd expect from a higher-priced hotel — free breakfast, free WiFi, kitchenettes and generous parking — at an honest, independent rate."
        image={IMAGES.breakfast}
        crumbs={[{ name: "Home", path: "/" }, { name: "Amenities", path: "/amenities" }]}
      />
      <section className="bg-bone py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14">
            {AMENITIES.map((a) => {
              const Icon = Icons[a.icon] || Icons.Check;
              return (
                <StaggerItem key={a.title}>
                  <div className="border-t border-stone/20 pt-6" data-testid={`amenity-${a.icon}`}>
                    <Icon className="text-amber" size={30} strokeWidth={1.3} />
                    <h3 className="font-serif text-2xl text-forest mt-4">{a.title}</h3>
                    <p className="text-stone mt-2 leading-relaxed text-[15px]">{a.copy}</p>
                  </div>
                </StaggerItem>
              );
            })}
          </Stagger>
        </div>
      </section>
      <section className="bg-forest text-bone py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <Reveal>
            <h2 className="font-serif text-4xl md:text-5xl">Ready when you are.</h2>
            <p className="mt-5 text-bone/75 leading-relaxed">
              Book direct for the best available rate and enjoy every amenity from the moment you arrive.
            </p>
            <div className="mt-8 flex justify-center">
              <BookButton label="Book Your Stay" testid="amenities-book" />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
